export default __webpack_public_path__ + "static/media/qldsBg.d1be2eab.png";